import { schema } from "normalizr";

const aufbauSchema = new schema.Entity("aufbau", {}, { idAttribute: "id" });

export { aufbauSchema };
